<template>
  <div class="breadcrumb" v-if="!loading">
    <div class="back-option">
      <router-link v-if="invoice" :to="{ name: back , params: { invoiceId: invoice.id }}">
        <svgicon name="arrow-down" class="icon" width="17" height="17" :original="true" />
      </router-link>
      <router-link v-else :to="{ name: back }">
        <svgicon name="arrow-down" class="icon" width="17" height="17" :original="true" />
      </router-link>
    </div>
    <div class="dropdown">
      <div class="dropdown-selected">{{title}}</div>
    </div>
    <div class="action-button" v-if="currentRoute === 'InvoiceDetails'">
      <button
        v-if="checkEditStatus && $hasPermission('update_invoice')"
        class="btn btn-secondary"
        @click="$emit('saveInvoice')">Save</button>
      <button
        v-if="$invoice.canCheckedInvoice(invoice.status) && $hasPermission('verify_invoice')"
        class="btn btn-primary"
        @click="$emit('checked'); $emit('saveInvoice', false)">Checked</button>
      <button class="btn btn-primary" v-if="checkEditStatus" @click="$emit('saveInvoice', false)">
        <router-link :to="{ name: 'InvoiceSummary'}">Next</router-link>
      </button>
      <button class="btn btn-primary" v-else>
        <router-link :to="{ name: 'InvoiceSummary'}">Next</router-link>
      </button>
    </div>
    <div class="action-button" v-if="currentRoute === 'InvoiceSummary'">
     <a class="btn btn-primary" target="_blank" :href="url(invoice.id)">Print</a>
      <button v-if="$invoice.canEditInvoice(invoice.status) && $hasPermission('reject_invoice')"
              class="btn btn-secondary"
              @click="$emit('reject')">
            Return
      </button>
      <button v-if="$invoice.canApproveInvoice(invoice.status) && $hasPermission('accept_invoice')"
              class="btn btn-primary"
              @click="$emit('approve')">Approve</button>

    </div>
    <div class="action-button" v-if="currentRoute === 'InvoiceVoucher'">
      <a class="btn btn-primary" @click="urlVoucher">Print</a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    back: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    invoice: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    checkEditStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentRoute: '',
    };
  },
  created() {
    this.currentRoute = this.$router.history.current.name;
  },
  methods: {
    constructBaseUrl() {
      const hostname = window.location.host;
      const isDevelopment = hostname.startsWith('localhost') || hostname.startsWith('127.0.0.1');
      return isDevelopment ? 'http://localhost:3000/api' : '/api';
    },
    url(invoiceId) {
      const baseURL = this.constructBaseUrl();
      return `${baseURL}/invoice/print_invoice/${invoiceId}`;
    },
    urlVoucher() {
      const baseURL = this.constructBaseUrl();
      const temp = `${baseURL}/invoice/print/${this.$route.params.invoiceId}`;
      window.open(temp, '_blank');
    },
  },
};
</script>
